import React from 'react';
import { Clock } from 'lucide-react';
import {Employee, Service} from "../../../types";
import placeHolderImg from "app/assets/images/landingImagePlaceholder.jpg";
import {Avatar} from "../../../components/avatar/avatar";

interface ServiceCardProps {
    service: Service ;
    practitioner?: Employee;
    onBook: (service: Service) => void;
    isSelected?: boolean;
    showAddButton?: boolean;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({
                                                            service,
                                                            practitioner,
                                                            onBook,
                                                            isSelected = false,
                                                            showAddButton = true
                                                        }) => {


    const getCategoryColor = (category: string) => {
        switch (category) {
            case 'facial':
                return 'bg-blue-50 text-blue-700 border-blue-200';
            case 'injectable':
                return 'bg-indigo-50 text-indigo-700 border-indigo-200';
            case 'laser':
                return 'bg-cyan-50 text-cyan-700 border-cyan-200';
            case 'body':
                return 'bg-teal-50 text-teal-700 border-teal-200';
            case 'wellness':
                return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'consultation':
                return 'bg-slate-50 text-slate-700 border-slate-200';
            default:
                return 'bg-slate-50 text-slate-700 border-slate-200';
        }
    };

    const getCategoryLabel = (category: string) => {
        // switch (category) {
        //     case 'facial':
        //         return 'Facial Treatment';
        //     case 'injectable':
        //         return 'Injectable';
        //     case 'laser':
        //         return 'Laser Treatment';
        //     case 'body':
        //         return 'Body Treatment';
        //     case 'wellness':
        //         return 'Wellness';
        //     case 'consultation':
        //         return 'Consultation';
        //     default:
        //         return 'Treatment';
        // }
        return category
    };

    const formatPrice = (price: number) => {
        // if (category === 'injectable' && service?.id === 'botox-consultation') {
        //     return `$${price}/unit`;
        // }
        // if (category === 'injectable' && service?.id === 'dermal-fillers') {
        //     return `$${price}/syringe`;
        // }
        return `$${price/100}`;
    };

    return (
        <div
            onClick={() => onBook(service)}
            className={`bg-white rounded-lg border transition-all duration-200 overflow-hidden cursor-pointer ${
                isSelected
                    ? 'border-blue-600 bg-blue-50'
                    : 'border-slate-200 hover:shadow-sm hover:border-slate-300'
            }`}
        >
            <div className="p-3">
                <div className="flex gap-4">
                    {/*{service?.image  && <div className="w-12 h-12 flex-shrink-0">*/}
                    {/*    <img*/}
                    {/*        width={100}*/}
                    {/*        height={100}*/}
                    {/*        src={placeHolderImg}*/}
                    {/*        alt={'service'}*/}
                    {/*        className="object-cover rounded-md"*/}
                    {/*    />*/}
                    {/*</div>}*/}

                    {/*{service?.image ?*/}
                    {/*    <img*/}
                    {/*        src={service?.image}*/}
                    {/*        alt={'service'}*/}
                    {/*        className="w-full h-full object-cover"*/}
                    {/*    />*/}

                    {/*    :*/}

                        <Avatar
                            type={'character'}
                            src={''}
                            size={54}
                            name={service?.title}
                        />



                    {/*}*/}




                    <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between mb-1">
                            <div className="flex-1">
                                <div className="flex items-center gap-2 mb-1">
                  <span className={`px-1.5 py-0.5 rounded text-xs font-medium border ${getCategoryColor(service?.serviceCategory.name)}`}>
                    {getCategoryLabel(service?.serviceCategory.name)}
                  </span>
                                </div>

                                <h3 className="font-medium text-slate-900 mb-1 text-sm">
                                    {service?.title}
                                </h3>

                                <div className="flex items-center gap-3 text-xs text-slate-500 mb-1">
                                    <div className="flex items-center gap-1">
                                        <Clock className="w-3 h-3" />
                                        <span>{service?.duration} min</span>
                                    </div>
                                    <div className="font-medium text-slate-900">
                                        {formatPrice(service?.priceCents)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
